module.exports = __webpack_public_path__ + "img/caprimo.8182b28c.svg";